module.exports = __webpack_public_path__ + "img/icon_instagram.f47f2dce.svg";